var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook-Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M11.7612 10.3619L12.0856 8.24841H10.0576V6.87693C10.0576 6.29873 10.3409 5.73513 11.2492 5.73513H12.1711V3.93575C12.1711 3.93575 11.3345 3.79297 10.5346 3.79297C8.86452 3.79297 7.7729 4.80522 7.7729 6.63766V8.24841H5.9165V10.3619H7.7729V15.471H10.0576V10.3619H11.7612Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-Icon.5e984818efd4b6cf7bff50b54726f737.svg";
export { ForwardRef as ReactComponent };